import React from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface AboutProps {
    isOpen: boolean;
    closeModal?: () => void;
}


const About: React.FC<AboutProps> = ({ isOpen, closeModal }) => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <Modal
                open={isOpen}
                onCancel={closeModal}
                title={t("faq")}
                footer={[
                    <Button key="close" onClick={closeModal}>
                        {t("close")}
                    </Button>,
                ]}
            >
                <div className='flex flex-col gap-4'>
                    <p>{t("about_title")}</p>
                    <p>{t("about_1")}</p>
                    <p>{t("about_2")}</p>
                    {i18n.language === "ms" ? <></> : <>
                        <div className='mt-4 flex flex-col gap-1'>
                            <p className='mb-2 underline'>{t("about_3")}</p>
                            <p>{t("about_4")}</p>
                            <p>{t("about_5")}</p>
                            <p>{t("about_6")}</p>
                            <p>{t("about_7")}</p>
                            <p>{t("about_8")}</p>
                        </div>
                        <div className='mt-2 flex flex-col gap-1'>
                            <p className='underline'>{t("about_9")}</p>
                            <p>{t("about_10")}</p>
                            <p>{t("about_11")}</p>
                            <p>{t("about_12")}</p>
                            <p>{t("about_13")}</p>
                            <p>{t("about_14")}</p>
                        </div>
                        <div className='mt-2 flex flex-col gap-1'>
                            <p className='underline'>{t("about_15")}</p>
                            <p>{t("about_16")}</p>
                            <p>{t("about_17")}</p>
                            <p>{t("about_18")}</p>
                            <p>{t("about_19")}</p>
                            <p>{t("about_20")}</p>
                            <p>{t("about_21")}</p>
                            <p>{t("about_22")}</p>
                            <p>{t("about_23")}</p>
                            <p>{t("about_24")}</p>
                            <p>{t("about_25")}</p>
                            <p>{t("about_26")}</p>
                            <p>{t("about_27")}</p>
                        </div>
                        <div>
                            <p className='font-bold text-[12px]'>{t("about_28")}</p>
                        </div>
                    </>}
                </div>
            </Modal>
        </>
    );
};

export default About;
